import addresses from './slice.addresses'
import affectedBundles from './slice.affectedBundles'
import auth from './slice.auth'
import carrierIntegrations from './slice.carrierIntegrations'
import carrierServices from './slice.carrierServices'
import clientsSlice from './slice.clients'
import directUpload from './slice.directUpload'
import featureFlags from './slice.featureFlags'
import integrations from './slice.integrations'
import locationsSlice from './slice.locations'
import pagesSlice from './slice.pages'
import portalsSlice from './slice.portals'
import portalTierPrices from './slice.portalTierPrices'
import shipFromAddresses from './slice.shipFromAddresses'
import shippingRateLogs from './slice.shippingRateLogs'
import thirdPartyBillings from './slice.thirdPartyBillings'
import vendorAddresses from './slice.vendorAddresses'
import vendors from './slice.vendors'
import warehouseAddresses from './slice.warehouseAddresses'
import warehouses from './slice.warehouses'
import zones from './slice.zones'

export default {
  addresses,
  auth,
  affectedBundles,
  clientsSlice,
  directUpload,
  featureFlags,
  integrations,
  carrierIntegrations,
  carrierServices,
  locationsSlice,
  pagesSlice,
  portalsSlice,
  portalTierPrices,
  shipFromAddresses,
  shippingRateLogs,
  thirdPartyBillings,
  vendorAddresses,
  warehouseAddresses,
  warehouses,
  vendors,
  zones
}
